export const TOLGEE_LANGUAGE_STORAGE_KEY = "__tolgee_currentLanguage";
